import './Logo.css';

export default function Logo() {
  return (
    <div title="Home" aria-label="Home Link" className="Logo">
      <h1>IC</h1>
    </div>
  );
}